import React, { FunctionComponent, PropsWithChildren } from 'react'
import { Navigate } from 'react-router'

import { isRenewalProposal, ProposalStatus } from '../../../domain'
import { AppPath } from '../../AppPath'
import { useProposal } from './ProposalProvider'
import {
  ProposalExpiredRoutes,
  ProposalInsufficientAccuracyRoutes,
  ProposalPolicyRoutes,
  ProposalQuoteRoutes,
  ProposalReferredRoutes,
} from './routes'

export const ProposalRouter: FunctionComponent<PropsWithChildren> = () => {
  const { proposal } = useProposal()

  if (isRenewalProposal(proposal)) {
    return <Navigate to={AppPath.HOME} />
  }

  switch (proposal.status) {
    case ProposalStatus.REFERRAL:
      return <ProposalReferredRoutes />
    case ProposalStatus.QUOTE_EXPIRED:
      return <ProposalExpiredRoutes />
    case ProposalStatus.QUOTE:
      return <ProposalQuoteRoutes />
    case ProposalStatus.INSUFFICIENT_ACCURACY:
      return <ProposalInsufficientAccuracyRoutes />
    case ProposalStatus.POLICY:
      return <ProposalPolicyRoutes />
  }
}
